module.exports = __webpack_public_path__ + "img/ico1.ee090b43.png";